import { AxiosInstance } from "axios";
import type {
  OneNoteGroup,
  OneNoteNotebook,
  OneNoteSection,
  OneNoteSectionGroup,
  OneNoteSite,
} from "./OneNoteSourceSettings.types";

export class OneNoteSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getGroups(
    boardId: string,
    connectionId: string,
  ): Promise<OneNoteGroup[]> {
    const response = await this.client.get<OneNoteGroup[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/onenote/groups`,
    );

    return response.data;
  }

  async getSites(
    boardId: string,
    connectionId: string,
    searchTerm: string,
  ): Promise<OneNoteSite[]> {
    const response = await this.client.get<OneNoteSite[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/onenote/sites?searchTerm=${encodeURIComponent(searchTerm)}`,
    );

    return response.data;
  }

  async getNotebooks(
    boardId: string,
    connectionId: string,
    location: string,
    locationId: string,
  ): Promise<OneNoteNotebook[]> {
    const response = await this.client.get<OneNoteNotebook[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/onenote/notebooks?location=${encodeURIComponent(location)}&locationId=${encodeURIComponent(locationId)}`,
    );

    return response.data;
  }

  async getSectionGroups(
    boardId: string,
    connectionId: string,
    location: string,
    locationId: string,
    notebookId: string,
  ): Promise<OneNoteSectionGroup[]> {
    const response = await this.client.get<OneNoteSectionGroup[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/onenote/sectionGroups?location=${encodeURIComponent(location)}&locationId=${encodeURIComponent(locationId)}&notebookId=${encodeURIComponent(notebookId)}`,
    );

    return response.data;
  }

  async getSections(
    boardId: string,
    connectionId: string,
    location: string,
    locationId: string,
    notebookId: string,
    sectionGroupId: string,
  ): Promise<OneNoteSection[]> {
    const response = await this.client.get<OneNoteSection[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/onenote/sections?location=${encodeURIComponent(location)}&locationId=${encodeURIComponent(locationId)}&notebookId=${encodeURIComponent(notebookId)}&sectionGroupId=${encodeURIComponent(sectionGroupId)}`,
    );

    return response.data;
  }
}
